<template>
  <v-layout row wrap>
    <v-flex xs4>{{ splitByAllCapitalLetters(field.Field) }}</v-flex>
    <v-flex xs8>{{ field.FieldValue }}</v-flex>
  </v-layout>
</template>

<script>
  import { splitByAllCapitalLetters } from '@/helpers/strings'
  export default {
    props: {
      field: Object,
    },
    methods: {
      splitByAllCapitalLetters,
    },
  }
</script>